import { IEtabContact, IContactCategory } from "@core/models";

export const etabContactMock = {
  [IEtabContact.etabId]: "8527758",
  [IEtabContact.id]: "001",
  [IEtabContact.email]: "lorem@ipsum.com",
  [IEtabContact.categories]: ["011"],
};

export const contactCategoriesMocks = [
  { [IContactCategory.id]: "011", [IContactCategory.name]: "billing" },
  { [IContactCategory.id]: "012", [IContactCategory.name]: "scheduling" },
];
